
// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import { Link } from 'react-router-dom';

import Crown from "examples/Icons/Crown";
import Medal from "examples/Icons/Medal";
import Sleep from "examples/Icons/Sleep";
import Alt from "examples/Icons/Alt";

const maxItemsToDisplay = 50

function GuildName({ guildname, guildid, colour }) {
    return (
        <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
            <Link to={{ pathname: '/guild', state: { guildname: guildname } }}>
                <VuiBox display="flex" alignItems="center" flexDirection="column">
                    <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                        {guildname}
                    </VuiTypography>
                    <VuiTypography pl="10px" variant="caption" color="text">
                        {guildid}
                    </VuiTypography>
                </VuiBox>
            </Link>
        </VuiBox>
    );
}

function GuildNameNoLink({ guildname, guildid, colour }) {
    return (
        <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
            <VuiBox display="flex" alignItems="center" flexDirection="column">
                <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                    {guildname}
                </VuiTypography>
                <VuiTypography pl="10px" variant="caption" color="text">
                    {guildid}
                </VuiTypography>
            </VuiBox>
        </VuiBox>
    );
}

function MemberName({ member, guildname, color = 'white' }) {
    return (
        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
            <Link to={{ pathname: '/member', state: { membername: member.name, guildname: guildname } }}>
                <VuiBox display="flex" flexDirection="column">
                    <VuiTypography variant="button" color={color} fontWeight="medium">
                        {member.name}
                    </VuiTypography>
                </VuiBox>
            </Link>
        </VuiBox>
    );
}

function StandardColumn({ text, color = 'white' }) {
    return (
        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
            <VuiBox display="flex" flexDirection="column">
                <VuiTypography variant="button" color={color} fontWeight="medium">
                    {text}
                </VuiTypography>
            </VuiBox>
        </VuiBox>
    );
}

function Requirements({ gw, ccl }) {
    return (
        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
            <VuiBox display="flex" flexDirection="column">
                <VuiTypography variant="button" color="white" fontWeight="medium">
                    {gw}
                </VuiTypography>
                <VuiTypography variant="caption" color="white" fontWeight="medium">
                    {ccl}
                </VuiTypography>
            </VuiBox>
        </VuiBox>
    );
}

export const getGuildRows = (columns, guilds) => {
    let rows = [];
    if (columns && guilds) {
        for (let i = 0; i < guilds.length; i++) {
            let guild = guilds[i];

            if (guild.members > 0) {
                let aceText = getAceText(guild.lastAce);
                let seText = getSEText(guild.sePosition, guild.seScore);
                let colour = "transparent";
                if (guild && guild.colour)
                    colour = convertHexToRGBA(guild.colour, 0.2);

                let powerInc = 'N/A';
                let pwrColor = 'white';
                if (guild.power && guild.previousPower) {
                    let power = getValueFromString(guild.power);
                    let previousPower = getValueFromString(guild.previousPower);
                    powerInc = convertStringToNumber(((power / previousPower) - 1) * 100, 1);
                    if (powerInc) {
                        if (powerInc > 0)
                            pwrColor = 'success';
                        else
                            pwrColor = 'error';
                    }
                    powerInc = powerInc + '%';
                }

                let row = {
                    pos: <StandardColumn text={i+1} />,
                    name: <GuildName guildname={guild.name} guildid={guild.ihid} colour={colour} />,
                    members: <StandardColumn text={guild.members} />,
                    power: <StandardColumn text={numberWithCommas(guild.power)} />,
                    "power inc": <StandardColumn text={powerInc} color={pwrColor} />,
                    ace: <StandardColumn text={aceText} />,
                    "se score": <StandardColumn text={seText} />,
                    requirements: <Requirements gw={guild.avgGW} ccl={guild.avgCCL} />,
                };

                rows.push(row);
            }
        }
    }

    return rows;
}

export const getFullMemberRows = (columns, members, guilds) => {
    let rows = [];

    try {
        if (members && guilds) {
            let numberItems = members.length;
            if (numberItems > maxItemsToDisplay)
                numberItems = maxItemsToDisplay;
            for (let i = 0; i < numberItems; i++) {
                let member = members[i];

                if (!member.name)
                    continue;

                let guild = guilds.find(item => item.name === member.guild);
                let colour = "transparent";
                if (guild && guild.colour)
                    colour = convertHexToRGBA(guild.colour, 0.2);
                let powerInc = 'N/A';
                let pwrColor = 'white';
                if (member.power && member.previousPower) {
                    let power = getValueFromString(member.power);
                    let previousPower = getValueFromString(member.previousPower);
                    powerInc = convertStringToNumber(((power / previousPower) - 1) * 100, 1);
                    if (powerInc) {
                        if (powerInc > 0)
                            pwrColor = 'success';
                        else
                            pwrColor = 'error';
                    }
                    powerInc = powerInc + '%';
                }
                var icondata = null;
                if (member.position.includes('L')) {
                    icondata =
                        <VuiBox display="flex" alignItems="center">
                            <VuiTypography variant="button" color='white' fontWeight="medium">
                            {i + 1}&nbsp;&nbsp;&nbsp;&nbsp;
                            </VuiTypography>
                            <Crown size="20px" />
                        </VuiBox>
                }
                else if (member.position.includes('O')) {
                    icondata =
                        <VuiBox display="flex" alignItems="center">
                            <VuiTypography variant="button" color='white' fontWeight="medium">
                            {i + 1}&nbsp;&nbsp;&nbsp;&nbsp;
                            </VuiTypography>
                            <Medal size="20px" />
                        </VuiBox>
                }
                else if (member.position.includes('I')) {
                    icondata =
                        <VuiBox display="flex" alignItems="center">
                            <VuiTypography variant="button" color='white' fontWeight="medium">
                            {i + 1}&nbsp;&nbsp;&nbsp;&nbsp;
                            </VuiTypography>
                            <Sleep size="20px" />
                        </VuiBox>
                }
                else if (member.position.includes('A')) {
                    icondata =
                        <VuiBox display="flex" alignItems="center">
                            <VuiTypography variant="button" color='white' fontWeight="medium">
                            {i + 1}&nbsp;&nbsp;&nbsp;&nbsp;
                            </VuiTypography>
                            <Alt size="20px" />
                        </VuiBox>
                }
                else {
                    icondata =
                        <VuiBox display="flex" alignItems="center">
                            <VuiTypography variant="button" color='white' fontWeight="medium">
                            {i + 1}&nbsp;&nbsp;&nbsp;&nbsp;
                            </VuiTypography>
                        </VuiBox>
                }

                let guildColumn
                if (guild) 
                    guildColumn = <GuildName guildname={guild.name} guildid={guild.ihid} colour={colour} />;
                else 
                    guildColumn = <GuildNameNoLink guildname='Ex-Members' colour={colour} />;

                let memberColumn
                if (guild)
                    memberColumn = <MemberName member={member} guildname={guild.name} />;
                else
                    memberColumn = <MemberName member={member} guildname='Ex-Members' />;

                let seHard = null;

                if (member.se && member.seeasy) {
                    seHard = (member.se - member.seeasy).toFixed(1);
                }

                let row = {
                    pos: icondata,
                    guild: guildColumn,
                    name: memberColumn,
                    power: <StandardColumn text={numberWithCommas(member.power)} />,
                    ss: <StandardColumn text={numberWithCommas(convertStringToNumber(member.ss))} />,
                    "power inc": <StandardColumn text={powerInc} color={pwrColor} />,
                    ccl: <StandardColumn text={numberWithCommas(member.ccl)} />,
                    "se score": <StandardColumn text={numberWithCommas(member.se)} />,
                    "se hard": <StandardColumn text={numberWithCommas(seHard)} />,
                    "s-tier": <StandardColumn text={numberWithCommas(member.stier)} />,
                    "a-tier": <StandardColumn text={numberWithCommas(member.atier)} />,
                    "d6": <StandardColumn text={numberWithCommas(member.d6)} />,
                    "d5": <StandardColumn text={numberWithCommas(member.d5)} />,
                    "d4": <StandardColumn text={numberWithCommas(member.d4)} />,
                    "d3": <StandardColumn text={numberWithCommas(member.d3)} />,
                    "d2": <StandardColumn text={numberWithCommas(member.d2)} />,
                    "d1": <StandardColumn text={numberWithCommas(member.d1)} />,
                    "t5": <StandardColumn text={numberWithCommas(member.t5)} />,
                    "t4": <StandardColumn text={numberWithCommas(member.t4)} />,
                    "t3": <StandardColumn text={numberWithCommas(member.t3)} />,
                    "t2": <StandardColumn text={numberWithCommas(member.t2)} />,
                    "t1": <StandardColumn text={numberWithCommas(member.t1)} />,
                    "v4": <StandardColumn text={numberWithCommas(member.v4)} />,
                    "v3": <StandardColumn text={numberWithCommas(member.v3)} />,
                    "v2": <StandardColumn text={numberWithCommas(member.v2)} />,
                    "v1": <StandardColumn text={numberWithCommas(member.v1)} />
                };
                rows.push(row);
            }
            if (members.length > maxItemsToDisplay) {
                rows.push({
                    name: <StandardColumn text={'Limited to ' + maxItemsToDisplay + ' records'} />
                });

            }
        }
    } catch (error) {
        alert(error);
    }

    return rows;
}


function numberWithCommas(x) {
    if (x)
        return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

function getValueFromString(value) {
    let result = 0;

    if (value) {
        value = value.toString().replaceAll(',', '');
        value = value.toString().replaceAll('%', '');

        result = parseFloat(value);
    }

    return result;
};


function convertStringToNumber(value, dp) {
    if (value) {
        var number = parseFloat(value.toString().replaceAll(",", ""));

        let decimalPlaces = 2;
        if (dp)
            decimalPlaces = dp;

        if (number >= 1000 || number <= -1000)
            return number.toLocaleString();
        else
            return number.toFixed(decimalPlaces);
    }
    else
        return value;
};

function getSEText(sePosition, seScore) {
    let seRank = "N/A";
    if (sePosition)
        seRank = ordinal_suffix_of(sePosition);
    let seScoreText = "N/A"
    if (seScore && seScore !== "0")
        seScoreText = seScore + " Mil";

    return seRank + " (" + seScoreText + ")";
}

function getAceText(ace) {
    let aceText = "N/A";
    if (ace) {
        aceText = ace;
        if (aceText === "1")
            aceText = "First";
        else if (aceText === "2")
            aceText = "Second";
        else
            aceText = "Top " + aceText;
    }
    return aceText;
}

function ordinal_suffix_of(i) {
    var j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
}

function convertHexToRGBA(hex, opacity) {
    const tempHex = hex.replace('#', '');
    const r = parseInt(tempHex.substring(0, 2), 16);
    const g = parseInt(tempHex.substring(2, 4), 16);
    const b = parseInt(tempHex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
};
